import * as React from 'react';

import {
    Props,
} from 'one-ui';


import Check from '@2fd/ant-design-icons/lib/Check'
import Close from '@2fd/ant-design-icons/lib/Close'

export interface CardBillingServiceNameProps extends Props {
    servicename: string;
    title:string;
    patientguarantor: boolean;
    paperless: boolean;
}

export const CardBillingServiceName = ({
    servicename,
    title,
    patientguarantor,
    paperless,
}: CardBillingServiceNameProps): JSX.Element => {

    return (
        <div className="outstand-account__box">
            <h3 className="font-medium text-base mb-10">{title}</h3>
            <div className="outstand-account__aside">
                <div className="text-lg text-black-85 font-medium mb-5">{servicename}</div>
                <div className="outstand-account__aside-row">
                    <div className="text-sm text-black-40 mr-10">Patient's Guarantor:</div>
                    {(patientguarantor) && <Check className="text-2xl" style={{ color: '#00a54f' }} />}
                    {(!patientguarantor) && <Close className="text-2xl" style={{ color: '#f66c59' }} />}
                </div>
                <div className="outstand-account__aside-row">
                    <div className="text-sm text-black-40 mr-10">Paperless:</div>
                    {(paperless) && <Close className="text-2xl" style={{ color: '#f66c59' }} />}
                    {(!paperless) && <Close className="text-2xl" style={{ color: '#f66c59' }} />}
                </div>
            </div>
        </div>
    );
}
